import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { COURIER_TEMPLATES_BASE_URL } from './helpers';
import { ICourierNotificationTemplatePreviewResponse } from './types';

export const useCourierTemplatePreview = (
  templateId?: string,
  enabled = true
) => {
  const url =
    enabled && templateId
      ? `${COURIER_TEMPLATES_BASE_URL}/${templateId}/preview`
      : null;

  const { data, error, isLoading, mutate } =
    useSWR<ICourierNotificationTemplatePreviewResponse>(url, SWRFetcher({ method: 'GET' }));

  return { data, error, isLoading, mutate };
};
